import axios from 'axios';

import { uiActions } from '../ui-slice';
import { landingPageActions } from './landing-page-slice';

import { doNavigation } from '../../utils/helper-functions';
import { POSTAL_CODE_VALIDATE_URL } from '../../constants/constants';

export const form1PostalCodeValidation = (postalCode, setFieldError, currentStep, navigateHook) => {
  return async (dispatch) => {
    dispatch(uiActions.setLoaderStatus({
      type: 'simple',
    }));

    axios
      .get(POSTAL_CODE_VALIDATE_URL.replace('%P_CODE%', postalCode))
      .then((res) => {
        if (res) {
          if (res.data?.status === 'success') {
            dispatch(landingPageActions.setPostalCode({ postalCode }));
            doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
          } else if (res.data?.status === 'error' && res.data?.message) {
            setFieldError('postalCode', res.data.message);
            dispatch(uiActions.clearLoaderStatus());
          }
        } else {
          setFieldError('postalCode', 'Se produjo un error desconocido al obtener los datos de código postal.');
          dispatch(uiActions.clearLoaderStatus());
        }
      })
      .catch((err) => {
        if (
          err.response
          && err.response.status
          && err.response.status === 422
        ) {
          setFieldError('postalCode', 'Código postal inválido');
        } else {
          setFieldError('postalCode', 'Se produjo un error desconocido.');
        }
        dispatch(uiActions.clearLoaderStatus());
        throw err;
      });
  };
};
